import React from 'react';

type Props = {
  method?: string;
};

const APIDocsMethod = ({ method = 'POST' }: Props) => {
  return (
    <>
      <div className="text">Method</div>
      <pre>
        <code className="method">{method}</code>
      </pre>
    </>
  );
};
export default APIDocsMethod;
